import {ErrorType} from "config/errors";
import {notify} from "config/sentry";

export const getFromSessionStorage = <T>(key: string, propName: keyof T): T[keyof T] | undefined => {
    try {
        const item = sessionStorage.getItem(key);
        if (item !== null) {
            try {
                const parsedItem = JSON.parse(item);
                if (typeof parsedItem === "object" && parsedItem !== null && propName in parsedItem) {
                    return parsedItem[propName];
                }
            } catch (error) {
                notify("Failed to get brand from session storage", ErrorType.DATA_PARSE_ERROR, {key, propName, error});
                return undefined;
            }
        }
    } catch (error) {
        notify("Unable to read brand from session storage", ErrorType.SESSION_STORAGE_ACCESS_DENIED, {
            error,
        });
    }

    return undefined;
};
